"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var mobx_1 = require("mobx");
var OverlayStack = (function () {
    function OverlayStack() {
        var _this = this;
        this.ESCAPE_KEY_CODE = 27;
        this.add = function (config) {
            _this._stack.push(config);
        };
        this.closeCurrent = function () {
            var current = _this._stack.pop();
            if (current) {
                current.onClose();
                _this.onClose();
            }
        };
        this.closeAll = function () {
            while (_this.currentCard) {
                _this.closeCurrent();
            }
        };
        this._stack = [];
    }
    Object.defineProperty(OverlayStack.prototype, "currentCard", {
        get: function () {
            return this._stack[this._stack.length - 1] || null;
        },
        enumerable: false,
        configurable: true
    });
    OverlayStack.prototype.onClose = function () {
        if (this._stack.length === 0) {
            this.onEmptyStack();
        }
    };
    OverlayStack.prototype.onEmptyStack = function () {
        $("body").css("overflow", "auto");
        $(document).off("keyup.overlay");
    };
    OverlayStack.prototype.onStackVisible = function () {
        var _this = this;
        $("body").css("overflow", "hidden");
        $(document).on("keyup.overlay", function (e) {
            var code = e.keyCode || e.which;
            if (code === _this.ESCAPE_KEY_CODE) {
                var last = lodash_1.default.last(_this._stack);
                if (!last.blockCloseByEscapeKey) {
                    _this.closeCurrent();
                }
            }
        });
    };
    __decorate([
        mobx_1.observable.shallow,
        __metadata("design:type", Array)
    ], OverlayStack.prototype, "_stack", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], OverlayStack.prototype, "add", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], OverlayStack.prototype, "currentCard", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], OverlayStack.prototype, "closeCurrent", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], OverlayStack.prototype, "closeAll", void 0);
    return OverlayStack;
}());
exports.default = OverlayStack;
